import URLBuilder from '@/common/network/URLBuilder';
import Storage, { KEY_DEBUG } from '@/common/services/Storage';

export default class DebugModeService {
  static get isEnabledInQuery() {
    return URLBuilder.params()[KEY_DEBUG] === '1';
  }

  static get isEnabled() {
    return Storage.hasObject(KEY_DEBUG, Storage.STORAGE_SESSION);
  }

  static get isEnabledInLocalStorage() {
    return Storage.hasObject(KEY_DEBUG, Storage.STORAGE_LOCAL);
  }

  static enableDebugMode() {
    if (DebugModeService.isEnabledInQuery) {
      DebugModeService.enable();
      DebugModeService.removeDebugFromQuery();

      return;
    }

    if (DebugModeService.isEnabled) {
      return;
    }

    if (DebugModeService.isEnabledInLocalStorage) {
      DebugModeService.enable();
    }
  }

  static enable() {
    Storage.saveObject(KEY_DEBUG, 1, Storage.STORAGE_SESSION);
  }

  static disable() {
    Storage.removeObject(KEY_DEBUG, Storage.STORAGE_SESSION);
  }

  private static removeDebugFromQuery() {
    const params = URLBuilder.params();

    delete params[KEY_DEBUG];

    URLBuilder.replace(`${window.location.pathname}${URLBuilder.buildQueryString(params)}${window.location.hash}`);
  }
}
